import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static values = {
    animation: { type: Number, default: 150 },
    ghostClass: { type: String, default: '' },
    dragClass: { type: String, default: '' },
    url: String,
    turbo: { type: Boolean, default: false },
    nested: { type: Boolean, default: false },
    handle: String
  }

  static targets = ['list']

  initialize () {
    this.sortable = []
  }

  connect () {
    if (!this.nestedValue) {
      this._createSortable(this.element, 0)
    }
  }

  listTargetConnected (list) {
    this._createSortable(list, this.listTargets.indexOf(list))
  }

  _createSortable (element, index) {
    const sortable = Sortable.create(element, {
      animation: this.animationValue,
      ghostClass: this.ghostClassValue,
      dragClass: this.dragClassValue
    })

    if (('sortableUrlValue' in element.dataset)) {
      const url = element.dataset.sortableUrlValue
      sortable.option('onUpdate', function (index, url) {
        this._save_sort(index, url)
      }.bind(this, index, url))
    }

    if (this.hasHandleValue) sortable.option('handle', this.handleValue)

    this.sortable[index] = sortable
  }

  async _save_sort (index, url) {
    const newSorting = this.sortable[index].toArray()
    const options = { body: JSON.stringify({ sortable_element_ids: newSorting }) }
    if (this.turboValue) Object.assign(options, { responseKind: 'turbo-stream', contentType: 'application/json' })
    const request = new FetchRequest('post', url, options)
    await request.perform()
  }

  disconnect () {
    this.sortable.forEach(sortable => {
      sortable.destroy()
    })
    this.sortable = undefined
  }
}
